import { FILE_EXPLORER_CONTENT_TYPE } from "../../constants"
import MobileIcon from "../../../icons/extra_icons/mobile_icon.svg"
import StorageIcon from "../../../icons/extra_icons/memory_card.svg"

export const MOBILE_DIRECTORIES= [
    {
        id: "0",
        label: "Internal Storage",
        contentType: FILE_EXPLORER_CONTENT_TYPE.FOLDER,
        subOptions: [
            {
                id: "0_0",
                label: "Course Cerificates",
                contentType: FILE_EXPLORER_CONTENT_TYPE.FOLDER,
                subOptions: [
                    {
                        id: "0_0_0",
                        label: "NGO",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.FOLDER,
                        subOptions: [
                            {
                                id: "0_0_0_0",
                                label: "Safecity Red Dot",
                                contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                                sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21933&authkey=!AIjWE02pVN-vzM0&em=2"
                            },
                            {
                                id: "0_0_0_1",
                                label: "Team Everest",
                                contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                                sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21932&authkey=!ACf2BWF4HUGOqBU&em=2"
                            },
                        ]
                    },
                    {
                        id: "0_0_1",
                        label: "DAS",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21925&authkey=!ABMUha4TdDWps0k&em=2"
                    },
                    {
                        id: "0_0_2",
                        label: "Google Digital Marketing",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21920&authkey=!AEnNgsg8f82zUNo&em=2"
                    },
                    {
                        id: "0_0_3",
                        label: "Debate Grad 8th",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21923&authkey=!AEiM2SzV0dMBZek&em=2"
                    },
                    {
                        id: "0_0_5",
                        label: "ADSAT 2012-14",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21924&authkey=!AAyErUYER2p1whY&em=2"
                    },
                    {
                        id: "0_0_6",
                        label: "IOT Hackathon",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21926&authkey=!ADjALxgt6oPVGwU&em=2"
                    },
                    {
                        id: "0_0_7",
                        label: "Puzzle Mania",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21928&authkey=!AC5pvsPoeT0HmlU&em=2"
                    },
                    {
                        id: "0_0_8",
                        label: "Android App Development",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21922&authkey=!APOPbrqs8bOYm58&em=2"
                    },
                    {
                        id: "0_0_9",
                        label: "Summer Training",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21927&authkey=!AM8bZ8VlEq52OXc&em=2"
                    },
                    {
                        id: "0_0_10",
                        label: "Chem Camp",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21929&authkey=!AOOEZ_MUJsLGHAU&em=2"
                    },
                ]
            },
            {
                id: "0_1",
                label: "College Degree",
                contentType: FILE_EXPLORER_CONTENT_TYPE.FOLDER,
                subOptions: [
                    {
                        id: "2_1_0",
                        label: "Grad. CSE 2018-22",
                        contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                        sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21939&authkey=!AKRxSI-1KkuWiTA&em=2"
                    }
                ]
            },
            {
                id: "0_2",
                label: "Resume 2023",
                contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
                sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21935&authkey=!APFlMBSpo7zByvs&em=2"
            }
        ]
    },
    {
        id: "1",
        label: "Sandisk 8GB",
        contentType: FILE_EXPLORER_CONTENT_TYPE.FOLDER,
    }

]


export const RESUME = {
    id: "0_2",
    label: "Resume 2023",
    contentType: FILE_EXPLORER_CONTENT_TYPE.PDF,
    sourceLink: "https://onedrive.live.com/embed?resid=16C0CC0BCA224705%21935&authkey=!APFlMBSpo7zByvs&em=2"
}
